import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import './assets/styles/css/font-awesome.min.css';
import './assets/styles/css/themify-icons.css';
import './assets/styles/css/flaticon.css';
import './assets/styles/css/animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/sass/style.scss';


const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(undefined);
